/* Personalisation toggle for the partner ranges.
 *
 * Its own file on purpose. This theme's larger scripts arrive truncated from
 * the CDN -- nyeleti-fixes.js is 26,897 bytes on the theme and 10,665 bytes by
 * the time a browser has it -- so anything living past that cut simply never
 * runs. The toggle was in there, past the cut, which is why the hidden fields
 * were still enabled and would have posted empty "Name To Print" and "Jersey
 * Number" lines on every order that did not ask for them.
 *
 * A file this small always arrives whole.
 */
(function () {
  'use strict';

  function wire() {
    var blocks = document.querySelectorAll('[data-personalise]');
    Array.prototype.forEach.call(blocks, function (block) {
      if (block.__nyeletiPersonalise) return;
      block.__nyeletiPersonalise = true;

      var toggle = block.querySelector('[data-personalise-toggle]');
      var extra = block.querySelector('[data-personalise-extra]');
      if (!toggle || !extra) return;

      var fields = extra.querySelectorAll('input, select, textarea');
      var learner = block.querySelector('[data-personalise-learner]');

      function sync() {
        var on = toggle.value === 'Yes';
        extra.hidden = !on;
        /* The learner's name is only needed when something is being printed,
           so it is asked for then and not before. */
        if (learner) {
          learner.required = on;
          if (on) learner.setAttribute('aria-required', 'true');
          else learner.removeAttribute('aria-required');
        }
        /* Disabled, not merely hidden: a disabled control is not submitted, so
           an order without personalisation carries no empty property lines for
           the production team to read past. */
        Array.prototype.forEach.call(fields, function (f) {
          f.disabled = !on;
          if (!on) f.value = '';
        });
      }

      toggle.addEventListener('change', sync);
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
  /* The product form is server-rendered, but re-run on load in case a variant
     change has replaced it. */
  window.addEventListener('load', wire);
})();
